import './Menu.css'
import { useState, useEffect, React } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import logo from '../../logo.png';
import Dropdown from 'react-bootstrap/Dropdown';
import { BoxArrowRight } from 'react-bootstrap-icons';
import { API, Auth } from 'aws-amplify';
import { ButtonToolbar, Button } from 'react-bootstrap';
const Menu = (props) => {
    const [typeOfAccount, settypeOfAccount] = useState("");

    async function signOut() {
        try {
            await Auth.signOut();
            window.location.href = '/'
        } catch (error) {
            console.log('error signing out: ', error);
        }
    }


    useEffect(() => {
        const token = props.user.signInUserSession.idToken.jwtToken
        const requestInfo = { headers: { Authorization: token } }
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
        .then(response => {           
			//localStorage.setItem('user_account_type', response.user_account_type)
            settypeOfAccount(response.user_account_type);
        })
        
        .then(error => {
            console.log(error)
        })
        
    }, []);


    return (
        <Navbar bg="dark" expand="lg" variant="dark">
            <Container fluid>
                <Navbar.Brand href="/">
                    <Image src={logo} className="logo" />
                </Navbar.Brand>
                <Navbar.Toggle varia-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Home</Nav.Link>
                        {/* <Nav.Link as={Link} to="/projects">Projects</Nav.Link> */}
                        {/* <Dropdown>
                          <Dropdown.Toggle variant="secondary" id="dropdown-basic" >
                            Projects
                          </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item><Nav.Link style={{'color':'black'}} as={Link} to="/ediscovery">eDiscovery</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{'color':'black'}} as={Link} to="/contractreview">Contract Review</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{'color':'black'}} as={Link} to="/caselawsearch">Case Law Search</Nav.Link></Dropdown.Item>
                            </Dropdown.Menu>
                         </Dropdown> */}
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic" >
                                Features
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/ediscovery">eDiscovery</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/contractreview">Contract Review</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/caselawsearch">Case Law Search</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/summarize">Summarize</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/question-answering">Q&A</Nav.Link></Dropdown.Item>
                                <Dropdown.Item><Nav.Link style={{ 'color': 'black' }} as={Link} to="/content-generation">Content Generator</Nav.Link></Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Nav.Link as={Link} to="/savedsearches">Saved Searches</Nav.Link>
                        <Nav.Link as={Link} to="/account">Account</Nav.Link>
                    </Nav>
                    <Nav>
                        <Nav.Link disabled>
                            <Button className='square rounded me-2' variant='secondary' style={{ 'color': 'white', 'textTransform': 'capitalize' }} disabled>
                                {typeOfAccount} Plan
                            </Button>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/account" active>
                            <Button className='square rounded me-4 border border-info' variant='primary'>
                                Upgrade Plan
                            </Button>
                        </Nav.Link>
                    </Nav>
                    <Nav className="justify-content-end">
                        {/* <Nav.Link  onClick={() => signOut()} className='sign-out'> */}
                        <Nav.Link onClick={() => signOut()} className='me-auto'>
                            {/* <BoxArrowRight /> */}
                            Sign out
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}
export default Menu